<template>
    <div style="width: 100%; position: fixed;display: flex;flex-direction: column;justify-content: center;align-items: center;">
        <canvas ref="canvas"></canvas>
        <!-- <audio ref="audio" :src="audioSrc" controls></audio> -->
        <play-bar></play-bar>
    </div>
</template>

<script>
import PlayBar from "@/components/PlayBar.vue";
export default {
    name: 'Music',
    data() {
        return {
            audioSrc: "require('')",
            isInit: false,
            audioCtx: null,
            analyser: null,
            buffer: null,
            canvas: null,
            ctx: null,
            maxValue: 255,
            audioStream: null,
        };
    },
    components: {
        PlayBar
    },
    mounted() {
        this.initCanvas();
        this.initAudioStream();
        this.draw(new Array(256).fill(0), 255)
        this.upDate()
    },
    created() {

    },
    methods: {
        initCanvas() {
            const canvas = this.$refs.canvas;
            console.log(canvas);
            const ctx = canvas.getContext('2d');
            const size = 800;
            canvas.width = size * devicePixelRatio;
            canvas.height = size * devicePixelRatio;
            canvas.style.width = canvas.style.height = size + 'px';
            this.canvas = canvas;
            this.ctx = ctx;
        },
        draw(datas, maxValue) {
            let cvs = this.canvas
            console.log(cvs);
            let ctx = this.ctx
            const r = cvs.width / 4 + 20 * devicePixelRatio;
            const center = cvs.width / 2;
            ctx.clearRect(0, 0, cvs.width, cvs.height);

            const hslStep = 360 / (datas.length - 1);
            const maxLen = cvs.width / 2 - r;
            const minLen = 2 * devicePixelRatio;
            for (let i = 0; i < datas.length; i++) {
                ctx.beginPath();
                const len = Math.max((datas[i] / maxValue) * maxLen, minLen);
                const rotate = hslStep * i;
                ctx.strokeStyle = `hsl(${rotate}deg, 65%, 65%)`;
                ctx.lineWidth = minLen;
                const rad = (rotate * Math.PI) / 180;
                const beginX = center + Math.cos(rad) * r;
                const beginY = center + Math.sin(rad) * r;
                const endX = center + Math.cos(rad) * (r + len);
                const endY = center + Math.sin(rad) * (r + len);
                ctx.moveTo(beginX, beginY);
                ctx.lineTo(endX, endY);
                ctx.stroke();
            }
        },
        initAudioStream() {
            navigator.mediaDevices.getUserMedia({ audio: true })
                .then((stream) => {
                    this.audioStream = stream;
                    //设备

                    if (this.isInit) {
                        return
                    }
                    console.log(stream);
                    this.audioCtx = new AudioContext();
                    //  初始化音频上下文 
                    this.analyser = this.audioCtx.createAnalyser()
                    //创建一个音频分析器节点

                    // analyser.getByteFrequencyData()
                    // 频率数据
                    this.analyser.fftSize = 512
                    // 定义分析结果数组长度
                    this.buffer = new Uint8Array(this.analyser.frequencyBinCount)
                    // analyser.getByteTimeDomainData(数组)
                    // 时域数据
                    const source = this.audioCtx.createMediaStreamSource(this.audioStream)
                    // 音频来源元素 
                    // const source = audioCtx.createMediaElementSource(stream)
                    // 获取音频来源 

                    source.connect(this.analyser)
                    // 音频来源和分析器链接

                    // analyser.connect(audioCtx.destination)
                    // 使用分析器节点连接上下文的输出目标 链接到喇叭
                    this.isInit = true
                })
                .catch((error) => {
                    console.error('error getting audio stream:', error);
                });
        },
        upDate() {
            requestAnimationFrame(this.upDate)
            const buffer = this.buffer
            if (!this.isInit) {
                return;
            }
            console.log(this.analyser);
            this.analyser.getByteFrequencyData(buffer);
            // const offset = math.floor((this.buffer.length * 2) / 3);
            const offset = Math.floor((buffer.length * 2) / 3)
            // 获取部分频率     // 
            const datas = new Array(offset * 2)
            for (let i = 0; i < offset; i++) {
                datas[i] = datas[datas.length - i - 1] = buffer[i]

            }
            this.draw(datas, 255)

        },
    },
    watch: {
        audioStream: {
            handler(newVal, oldVal) {
                // console.log(newVal);
                if (newVal) {
                    this.initAudioStream();
                }
            },
            deep: true,
        },
    },

    Deforedestroy() {
        if (this.audiostream) {
            this.audiostream.foreach((track) => {
                track.stop();
            });
        }
    },
};
</script>

<style lang="less">
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    height: 60vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #06252e;
}

audio {
    margin: 0 auto;
    position: absolute;
    left: 50%;
    bottom: 30px;
    transform: translateX(-50%);
}

canvas {
    display: block;
    margin: 0 auto;
    background: transparent;
}
</style>